import React, { useState } from 'react'
import CevNav from './cev/CevNav'
import crumbs from '../assets/img/cev/bluish-green-1.jpg'
import '../styles/cev.scss'

export default function ClosedEyeVisual() {
  const [ hovered, setHovered ] = useState('');

  const hoverStyle = {
    backgroundImage: `url(${ hovered })` 
  }

  const regStyle = { 
    backgroundImage: `url(${ crumbs })`
  }

  return (
    <div className='cev' style={ hovered ? hoverStyle : regStyle }>
      <div className='cev-filter'>
        <CevNav setHovered={ setHovered } hovered={ hovered } />
      </div>
    </div>
  )
}